import { useEffect, useState } from 'react'

import { analyticsContext } from 'contexts'
import { DatePicker, TimePicker } from 'components'
import { formatDate } from 'utils'

import './styles.scss'
import { isValid } from 'date-fns'

const splitDateTime = (isoString: string | null) => {
  if (!isoString) return { date: '', time: '', seconds: '' }

  return {
    date: formatDate(isoString, 'dd.MM.yyyy'),
    time: formatDate(isoString, 'HH:mm'),
    seconds: formatDate(isoString, 'ss'),
  }
}

const combineToISO = (dateStr: string, timeStr: string, secondsStr: string) => {
  const [day, month, year] = dateStr.split('.')

  const [hours, minutes] = timeStr.split(':')
  const date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
    Number(secondsStr),
  )

  return isValid(date) ? date.toISOString() : ''
}

interface Props {
  label: string
  value: string
  onChange: (value: string) => void
  eventType?: string
  selectTimeOnRender?: boolean
}

export const TimeInputs = (props: Props) => {
  const { label, value, eventType, selectTimeOnRender, onChange } = props

  const [date, setDate] = useState('')
  const [time, setTime] = useState('')
  const [secs, setSecs] = useState('')

  useEffect(() => {
    if (value) {
      const { date: initDate, time: initTime, seconds } = splitDateTime(value || '')
      setDate(initDate)
      setTime(initTime)
      setSecs(seconds)
    }
  }, [value])

  useEffect(() => {
    const val = combineToISO(date, time, secs)

    onChange(val)
  }, [date, time, secs, onChange])

  const onChangeDate = (date: string) => setDate(date)

  const onFocusDate = () =>
    analyticsContext.trackEvent('date_time_changed', { field: 'DATE', param: eventType })

  const onTrackDate = (open: boolean) => {
    if (open) {
      analyticsContext.trackEvent('date_time_changed', { field: 'DATE', param: eventType })
    }
  }

  const onChangeTime = (time: string) => setTime(time)

  const onFocusTime = () =>
    analyticsContext.trackEvent('date_time_changed', { field: 'TIME', param: eventType })

  const onTrackTime = (open: boolean) => {
    if (open) {
      analyticsContext.trackEvent('date_time_changed', { field: 'TIME', param: eventType })
    }
  }

  return (
    <div className="time-inputs">
      <div className="input-label">{label}</div>
      <div className="inputs-wrapper">
        <DatePicker
          className="date-input"
          value={date}
          onFocus={onFocusDate}
          onModalOpened={onTrackDate}
          onChange={onChangeDate}
          scrollToOnFocus
        />

        <TimePicker
          value={time}
          onChange={onChangeTime}
          onFocus={onFocusTime}
          onModalOpened={onTrackTime}
          className="time-input"
          selectOnRender={selectTimeOnRender}
          scrollToOnFocus
          selectOnFocus
        />
      </div>
    </div>
  )
}
